import { ServerModelWithDateStrings } from "@teamprevent/common/utils";
import axios from "axios";

import { UserSearchListModel, parseUserModel } from "./model";

class UserSearchApi {

    private readonly apiUrl = "/api/userSearch";

    public async getAll(filters?: {
        emailAddress?: string;
        secondaryReference?: string;
        phoneNumber?: string;
        dateOfBirth?: string;
    }): Promise<UserSearchListModel[]> {
        const response = await axios.get<ServerModelWithDateStrings<UserSearchListModel>[]>(this.apiUrl, { params: filters });
        const data = response.data;
        const employees = data.map(parseUserModel);
        return employees;
    }
}

export const userSearchApi = new UserSearchApi();
